import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {StatusInfo} from '@catfeatures/types';
import {Port} from '@catmodules/models/ports/types';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class PortService extends RestHttpService<Port> {

  constructor(service: Restangular) {
    super('ports', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ports/services/port.service.ts